<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const props = defineProps({
    images: {
        type: Object,
        required: true,
        default: () => [],
    },
})
</script>

<template>
    <div>
        <swiper
            loop
            :watchSlidesProgress="true"
            :navigation="true"
            :pagination="true"
            :modules="[Navigation, Pagination]"
            :breakpoints="{
                100: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
            }"
        >
            <swiper-slide
                v-for="image in images"
                :key="image.id"
                class="aspect-video cursor-pointer selection:bg-transparent"
                @click="openModal(image)"
            >
                <img
                    class="h-[18rem] w-full rounded-xl bg-black object-cover object-center md:h-[27em] xl:h-[30rem]"
                    :src="'/storage/blogs/' + image.imageable_id + '/images/' + image.image"
                    :alt="image.image"
                />
            </swiper-slide>
        </swiper>
    </div>
</template>
